import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../shared/hooks/useNotification';
import { subscribeAgentPhoneMessages } from '../../services/agentPhone/agentPhoneBridge';

/**
 * Listens for inbound screen-pop events from the agent phone window and routes agents to chats.
 */
const AgentPhoneScreenPopListener = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  useEffect(() => {
    const applyPop = (clientId?: string | null, clientName?: string | null) => {
      if (!clientId) {
        return;
      }
      navigate(`/app/my-chats`);
      showNotification(
        clientName ? `Incoming call: ${clientName} — opening chats` : 'Incoming call — opening chats',
        'info',
      );
    };

    return subscribeAgentPhoneMessages((message) => {
      if (message.type === 'SCREEN_POP') {
        applyPop(message.clientId, message.clientName);
      }
    });
  }, [navigate, showNotification]);

  return null;
};

export default AgentPhoneScreenPopListener;
